module.exports = __webpack_public_path__ + "img/材料力学5_9_3.279d391e.jpg";